import Login from "../Login/Login";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminLayout from "../Router/AdminLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import AuthorListing from "../pages/Author/AuthorListing";
import Category from "../pages/category/Category";
import Tags from "../pages/tags/Tags";
import BlogListing from "../pages/blogs/BlogListing";
import AddBlog from "../pages/blogs/AddBlog";
import EditBlog from "../pages/blogs/EditBlog";
import Contact from "../pages/Contact/Contact";
import CorporateQuery from "../pages/Contact/CorporateQuery";
import SeoListing from "../pages/Seo/SeoListing";
import SeoCreate from "../pages/Seo/SeoCreate";
import SeoEdit from "../pages/Seo/SeoEdit";
import EditClientLogo from "../pages/clientLogos/EditClientLogo";
import ClientLogos from "../pages/clientLogos/ClientLogos";
import AddClientLogo from "../pages/clientLogos/AddClientLogo";



import DynamicListing from "../pages/DynamicPage/DynamicListing";
import AddDynamic from "../pages/DynamicPage/AddDynamic";
import EditDynamic from "../pages/DynamicPage/EditDynamic";


import FaqListing from "../pages/Faq/FaqListing";
import AddFaq from "../pages/Faq/AddFaq";
import EditFaq from "../pages/Faq/EditFaq";
import SchemaManagement from "../pages/schema-management/SchemaManagement";
import SitemapEditor from "../pages/sitemap/SitemapEditor";
import LlmsManagement from "../pages/Llms/LlmsManagement";
import RobotsManagement from "../pages/Robots/RobotsManagement";
import EmailManagement from "../pages/EmailManagement/EmailManagement";
import AddEmailManagement from "../pages/EmailManagement/AddEmailManagement";
import EditEmailManagement from "../pages/EmailManagement/EditEmailManagement";
import Users from "../pages/Rbac/Users";
import Roles from "../pages/Rbac/Roles";
import Permissions from "../pages/Rbac/Permissions";
import GalleryListing from "../pages/gallery/GalleryListing";
import AddGallery from "../pages/gallery/AddGallery";
import EditGallery from "../pages/gallery/EditGallery";
import GalleryCategories from "../pages/gallery/GalleryCategories";
import AddGalleryCategory from "../pages/gallery/AddGalleryCategory";
import EditGalleryCategory from "../pages/gallery/EditGalleryCategory";
import DownloadBrouchure from "../pages/Contact/DownloadBrouchure";


export default function Router() {
  return (
    <>
      <Routes>
        <Route path={"login"} element={<Login />} />
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="author" element={<AuthorListing />} />
          <Route path="category" element={<Category />} />
          <Route path="tag" element={<Tags />} />
          <Route path="blog" element={<BlogListing />} />
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="edit-blog/:blog_id" element={<EditBlog />} />
        
          <Route path="contact" element={<Contact/>} />
          <Route path="contact-page-query" element={<Contact/>} />
          <Route path="corporate-query" element={<CorporateQuery/>} />
           <Route path="broucher-page-query" element={<DownloadBrouchure/>} />
          <Route path="seo" element={<SeoListing/>} />
          <Route path="global-seo" element={<SchemaManagement/>} />
          <Route path="schema-management" element={<Navigate to="/global-seo" replace />} />
          <Route path="llms" element={<LlmsManagement/>} />
          <Route path="robots" element={<RobotsManagement/>} />
          <Route path="email-management" element={<EmailManagement/>} />
          <Route path="add-email-management" element={<AddEmailManagement/>} />
          <Route path="edit-email-management/:dynamicemail_id" element={<EditEmailManagement/>} />
          <Route path="users" element={<Users/>} />
          <Route path="roles" element={<Roles/>} />
          <Route path="permissions" element={<Permissions/>} />
          <Route path="sitemap" element={<SitemapEditor/>} />
          <Route path="add-seo" element={<SeoCreate/>} />
          <Route path="edit-seo/:seo_id" element={<SeoEdit/>} />  
 

          <Route path="client-logos" element={<ClientLogos />} />
          <Route path="add-client-logo" element={<AddClientLogo />} />
          <Route path="edit-client-logo/:clientlogo_id" element={<EditClientLogo />} />
          <Route path="gallery-categories" element={<GalleryCategories />} />
          <Route path="add-gallery-category" element={<AddGalleryCategory />} />
          <Route path="edit-gallery-category/:gallerycategory_id" element={<EditGalleryCategory />} />
          <Route path="gallery" element={<GalleryListing />} />
          <Route path="add-gallery" element={<AddGallery />} />
          <Route path="edit-gallery/:gallery_id" element={<EditGallery />} />

          <Route path="dynamic" element={<DynamicListing />} />
          <Route path="add-dynamic" element={<AddDynamic />} />
          <Route path="edit-dynamic/:service_id" element={<EditDynamic />} />
          <Route path="faq" element={<FaqListing />} />
          <Route path="add-faq" element={<AddFaq />} />
          <Route path="edit-faq/:faq_id" element={<EditFaq />} />
        </Route>
      </Routes>
    </>
  )
}
